import { ReactComponent as ChatBubbles } from "./icons/chatBubbles.svg";
import { ReactComponent as Alert } from "./icons/alert.svg";
import { ReactComponent as Grid4X4 } from "./icons/grid4x4.svg";
import { ReactComponent as XLogs_X } from "./icons/xlogs_X.svg";
import { ReactComponent as Commander } from "./icons/commander.svg";
import { ReactComponent as Home } from "./icons/home.svg";
import { ReactComponent as FourHorizontalLines } from "./icons/horizontalLines4.svg";
import { ReactComponent as Hamburger } from "./icons/horizontalLines3.svg";
import { ReactComponent as Tools } from "./icons/tools.svg";
import { ReactComponent as Hierarchy } from "./icons/hierarchy.svg";
import { ReactComponent as Filter } from "./icons/filter.svg";
import { ReactComponent as Caret } from "./icons/caret.svg";
import { ReactComponent as CaretOutline } from "./icons/caret_outline.svg";
import { ReactComponent as Inbox } from "./icons/inbox.svg";
import { ReactComponent as TwoPeople } from "./icons/person_multiple.svg";
import { ReactComponent as Bell } from "./icons/bell.svg";
import { ReactComponent as Close } from "./icons/close.svg";
import { ReactComponent as Person } from "./icons/person.svg";
import { ReactComponent as Help } from "./icons/help.svg";
import { ReactComponent as Phone } from "./icons/phone.svg";
import { ReactComponent as AlarmClock } from "./icons/alarm_clock.svg";
import { ReactComponent as Files } from "./icons/files.svg";
import { ReactComponent as Calendar } from "./icons/calendar.svg";
import { ReactComponent as SmallCheck } from "./icons/check_small.svg";
import { ReactComponent as PlusSign } from "./icons/add_sign.svg";
import { ReactComponent as Gear } from "./icons/gear.svg";
import { ReactComponent as AvatarWithCircleOutline } from "./icons/avatar.svg";
import { ReactComponent as Ellipse } from "./icons/ellipse.svg";
import { ReactComponent as Logout } from "./icons/logout.svg";
import { ReactComponent as Email } from "./icons/email.svg";
import { ReactComponent as LiveChat } from "./icons/livechat.svg";
import { ReactComponent as Pencil } from "./icons/pencil.svg";
import { ReactComponent as DocText } from "./icons/doctext.svg";
import { ReactComponent as DownChevron } from "./icons/ddown_chevorn.svg";
import { ReactComponent as Refresh } from "./icons/refresh.svg";
import { ReactComponent as Folder } from "./icons/folder.svg";
import { ReactComponent as PhotoPlaceholder } from "./icons/photo_placeholder.svg";
import { ReactComponent as Excel } from "./icons/excel.svg";
import { ReactComponent as PDF } from "./icons/pdf.svg";
import { ReactComponent as LoadingAnimation } from "./icons/loading_animated.svg";
import { ReactComponent as CSV } from "./icons/csv.svg";
import { ReactComponent as Print } from "./icons/print.svg";
import { ReactComponent as Merge } from "./icons/merge.svg";
import { ReactComponent as Search } from "./icons/magnifying_glass.svg";
import { ReactComponent as Trash } from "./icons/trash.svg";
import { ReactComponent as Information } from "./icons/information.svg";
import { ReactComponent as Copy } from "./icons/copy.svg";
import { ReactComponent as PrescribingProviderIcon } from "./icons/prescribing_provider_icon.svg";
import {ReactComponent as ArrowOutWard} from './icons/arrow_outward.svg'
import  EditIcon  from "./icons/edit-min.png";

const MSBICONS = {
  ThreeHorizontalLines: Hamburger,
  Hamburger: Hamburger,
  Alert,
  Files,
  Calendar,
  ChatBubbles,
  Grid4X4,
  XLogs_X,
  Commander,
  Home,
  FourHorizontalLines,
  Tools,
  Hierarchy,
  Filter,
  Folder,
  Caret,
  CaretOutline,
  Inbox,
  TwoPeople,
  PhotoPlaceholder,
  Bell,
  Close,
  Person,
  Help,
  Phone,
  AlarmClock,
  SmallCheck,
  PlusSign,
  Gear,
  AvatarWithCircleOutline,
  Ellipse,
  Logout,
  Email,
  LiveChat,
  Pencil,
  DocText,
  DownChevron,
  Refresh,
  PDF,
  Excel,
  LoadingAnimation,
  CSV,
  Print,
  Merge,
  Search,
  Trash,
  Information,
  Copy,
  PrescribingProviderIcon,
  ArrowOutWard,
  EditIcon
};

export default MSBICONS;
